<template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Website Appearance - Themes"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'OnboardingThemes',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-colours',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You have full access to a variety of unique themes when creating a website, all of which are optimised for maximum conversion. You can change the theme of your website at any time without having to re-populate the content.</p>

        <p>We are constantly improving themes and adding new ones!</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>
